<template>
    <div class="order-progress" :class="{'order-progress--agency': step == 2, 'order-progress--booking': step >= 3}">
        <div class="order-progress__wrapper">
            <div class="order-progress__steps">
                <div class="order-progress-item" v-for="(itemStep, stepKey) in steps" 
                    :key="stepKey" 
                    :class="{'order-progress-item--filled': stepKey < step, 'order-progress-item--current': step == stepKey}">
                    <span class="order-progress-item__text" v-text="itemStep"></span>
                </div>
                <div class="order-progress-bar">
                    <div class="order-progress-bar__fill"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script type="text/javascript">
    export default {
        props: {
            step: {type: Number, default: 0}
        },
        data() {
            return {
                translations: APP_CONFIG.TRANSLATION.ORDER_PROGRESS,
                steps: APP_CONFIG.TRANSLATION.ORDER_PROGRESS.steps
            }
        },
    }
</script>